module.exports = __webpack_public_path__ + "helveticaneueltstd-lt-webfont.56d224b07e975503c393.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/assets/fonts/helveticaneueltstd-lt-webfont.eot
// module id = ../../../../../src/assets/fonts/helveticaneueltstd-lt-webfont.eot
// module chunks = styles